const config = {
    'font_path': 'docma',
    'ad_recall': false,
    'graph_title_font': 'Poppins',
    'graph_axis_title_font': 'Poppins',
    'graph_text_font': 'Amiko',
    'primary': '#EE8500',
    'secondary': '#F3A815',
    'third': '#000000',
    'main_logo_path': './assets/docma-logo-reversed.svg',
    'singleOperator': false
}
export default {config};